import { render, staticRenderFns } from "./pdfview-modal.vue?vue&type=template&id=588aa9df&"
import script from "./pdfview-modal.vue?vue&type=script&lang=tsx&"
export * from "./pdfview-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./pdfview-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports